import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import { SystemModeProvider } from "./context/SystemModeContext";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <SystemModeProvider>
      <App />
    </SystemModeProvider>
  </React.StrictMode>,
);
